module.exports = __webpack_public_path__ + "static/redundant-9721090acbdd60c1206116af9b5ecf81.svg";